import { Box, Container, Text, VStack } from '@chakra-ui/react';
import { BODY_TEXT, HEADLINE_TEXT } from './constants';
import { EvasiveLogo } from './components/EvasiveLogo';
import { Footer } from './components/Footer';
import { PlatformAccessCta } from './components/PlatformAccessCta';

function Hero() {
  return (
    <Box
      as="header"
      id="top"
      flex="1"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
      overflow="hidden"
      py={{ base: 4, md: 8 }}
    >
      <Box
        position="absolute"
        top="-300px"
        left="50%"
        transform="translateX(-50%)"
        w="1200px"
        h="1200px"
        bg="radial-gradient(ellipse at center, rgba(255,92,65,0.15) 0%, rgba(255,92,65,0.05) 40%, transparent 70%)"
        pointerEvents="none"
        zIndex={0}
      />
      <Container maxW="container.content" position="relative" px={{ base: 4, md: 6 }}>
        <VStack spacing={{ base: 3, md: 5 }} textAlign="center">
          <EvasiveLogo />
          <VStack spacing={{ base: 3, md: 4 }} maxW="780px" px={{ base: 1, sm: 0 }}>
            <Box
              as="h1"
              fontSize={{ base: 'xl', sm: '2xl', md: '3xl', lg: '4xl' }}
              fontWeight="extrabold"
              lineHeight="1.15"
              color="white"
            >
              {HEADLINE_TEXT}
            </Box>
            <Text fontSize={{ base: 'sm', md: 'lg' }} color="gray.400" lineHeight="1.55">
              {BODY_TEXT}
            </Text>
          </VStack>
          <PlatformAccessCta />
        </VStack>
      </Container>
    </Box>
  );
}

function App() {
  return (
    <Box minH="100dvh" bg="gray.900" display="flex" flexDirection="column">
      <Box flex="1" display="flex" flexDirection="column" minH={0}>
        <Hero />
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
